import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { countryCodeToEmoji } from "./countries";
import { PlayerAvatar } from "./PlayerAvatar";
import { playerDisplayName } from "./PlayerDisplayNameLink";
/**
 * Shared team-page player row: whole row links to the player, showing a
 * nationality flag + name next to the avatar. `leading` fills an optional
 * slot before the avatar (e.g. a squad number); `trailing` fills an optional
 * slot at the end of the row (e.g. match goal/card glyphs).
 */
export var PlayerListRow = function (_a) {
    var player = _a.player, leading = _a.leading, trailing = _a.trailing, _b = _a.showDivider, showDivider = _b === void 0 ? false : _b;
    return (_jsx(Link, { to: "/players/".concat(player.id, "/"), style: { textDecoration: "none", color: "inherit" }, children: _jsxs(Box, { sx: {
                py: 1.5,
                px: 2,
                display: "flex",
                alignItems: "center",
                "&:hover": { backgroundColor: "#f8f9ff" },
                transition: "all 0.2s ease",
                borderBottom: showDivider ? "1px solid rgba(0,0,0,0.08)" : "none",
            }, children: [leading, _jsx(PlayerAvatar, { player: player, size: 40 }), _jsx(Box, { sx: { ml: 2, flex: 1, minWidth: 0 }, children: _jsxs(Typography, { variant: "body1", sx: { fontWeight: 600 }, children: [player.nationality
                                ? "".concat(countryCodeToEmoji(player.nationality), " ")
                                : "", playerDisplayName(player)] }) }), trailing && _jsx(Box, { sx: { ml: 1, flexShrink: 0 }, children: trailing })] }) }));
};
